<div id="<%= dom_id(message) %>" class="p-3 bg-white rounded shadow-sm" data-chat-target="message">
  <div class="flex justify-between items-start">
    <div>
      <span class="font-semibold text-blue-600"><%= message.username %></span>
      <span class="text-gray-400 text-sm ml-2"><%= message.created_at.strftime("%H:%M") %></span>
    </div>
    <%= button_to "×", message_path(message), method: :delete,
        class: "text-gray-400 hover:text-red-600 text-xl leading-none",
        data: { turbo_confirm: "Delete this message?" } %>
  </div>
  <p class="text-gray-700 mt-1"><%= message.body %></p>
</div>
